import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  max-width: 650px;
  margin: 40px auto 0;
  padding: 24px clamp(24px, calc((100vw - 320px) / 2), 170px);

  background: var(--white);
  border-radius: 4px;

  > h1,
  > p {
    align-self: center;
    text-align: center;
  }

  > h1 {
    font: var(--600-24);
    margin: 0 -14px;
  }

  > p {
    margin-top: -8px;
    margin-bottom: 16px;
    max-width: 230px;
  }

  [type='submit'] + a {
    text-align: center;
  }

  button:first-of-type {
    margin-top: 8px;
  }
`
